// The backend email renderer (apps/automations/models.py) substitutes merge
// tags with Python's `string.Template` (`$tag` / `${tag}`), never Unlayer's
// default `{{tag}}` mustache syntax. Every merge-tag picker (Unlayer's
// `mergeTags` config, and any custom tag-insertion UI) must insert the
// braced `${tag}` form so the backend actually resolves it.
//
// The braced form is preferred over the bare `$tag` form because
// `string.Template` treats `$tag` as extending across all following
// identifier characters (e.g. `$first_nameXYZ` would be parsed as the
// single identifier `first_nameXYZ`, not `first_name` followed by literal
// text). `${tag}` has an explicit boundary and avoids that ambiguity.
export const formatMergeTagToken = (tag) => `\${${tag}}`;
